module.exports = __webpack_public_path__ + "img/ep8-1a.c6c141df.png";